import { render, staticRenderFns } from "./PriceDisplay.vue?vue&type=template&id=b6464010&scoped=true"
import script from "./PriceDisplay.vue?vue&type=script&lang=js"
export * from "./PriceDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6464010",
  null
  
)

export default component.exports